import classNames from 'classnames';

export function MapCard({ className, children }) {
  return <div className={classNames('MapCard', className)}>{children}</div>;
}
